import axios, { AxiosError, AxiosResponse } from "axios";
import store, { types } from "../store";
import { serialize } from "object-to-formdata";

const hostname = process.env.VUE_APP_ARPA_API_URL
  ? process.env.VUE_APP_ARPA_API_URL
  : "https://int5-dev.greenecountymo.gov/arpa-api";
const baseURL = hostname + "/?route=";

const httpClient = axios.create({
  baseURL,
  timeout: 60000,
  withCredentials: true,
});

httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response.data.data;
  },
  (err: AxiosError) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const status = err.response?.status || 500;
    const message = err.response?.data?.error || null;

    // we can handle global errors here
    switch (status) {
      // authentication (token related issues)
      case 401:
      case 403:
        return store.dispatch(types.LOGOUT);

      // bad request
      case 400: {
        return Promise.reject(message);
      }

      // generic api error (server related) unexpected
      default: {
        return store.dispatch(types.SET_SERVER_ERROR, true);
      }
    }
  }
);

export default {
  // User/auth
  getCurrentUser() {
    return httpClient.get("current-user");
  },
  register(payload: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
  }) {
    return httpClient.post("register", payload);
  },
  login(email: string, password: string) {
    return httpClient.post("login", { email, password });
  },
  logout() {
    return httpClient.post("logout");
  },
  requestPasswordReset(payload: { email: string }) {
    return httpClient.post("request-password-reset", payload);
  },
  resetPassword(payload: { email: string; password: string; token: string }) {
    return httpClient.post("reset-password", payload);
  },

  // Application
  newApplication() {
    return httpClient.post("new-application");
  },
  loadUserApplications(payload: { userId: number }) {
    return httpClient.get("load-applications&userId=" + payload.userId);
  },
  loadApplication(payload: { applicationId: number }) {
    return httpClient.get(
      "load-application&applicationId=" + payload.applicationId
    );
  },
  saveStep(payload: {
    applicationId: number;
    formFields?: { [x: string]: number | null | string | boolean };
    newCurStepNum?: number;
  }) {
    const formDataPayload = serialize(payload);
    return httpClient.post("save-step", formDataPayload, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  },
  submitForm(payload: { applicationId?: number }) {
    return httpClient.post("submit-application", payload);
  },
};
